<template>
  <ValidationObserver v-slot="{ invalid }" slim>
    <Layout class="EditScheduling">

      <LayoutSection v-if="notification.type === 'manual'">
        <Card>
          <CardSection>
            <div v-if="timingWarning">{{ timingWarning }}</div>
          </CardSection>
          <CardSection>
            <validation-provider name="product" immediate rules="required" v-slot="{ errors }">
              <DatePicker
                :placeholder="$t('Choose a date')"
                v-model="chosenDate"
                :label="$t('NotificationsApp.Date and Time to Send')"
                :help-text="$t('NotificationsApp.chooseDateHelp', [`${accountTimezone}`])"
                :withTime="true"
              />
              <!-- updateTimingWarning -->
            </validation-provider>
          </CardSection>
          <CardSection>
            <Checkbox
              :label="$t('NotificationsApp.Send in users local time?')"
              v-model="useUserTime"
              :disabled="noEditing"
              :help-text="$t('NotificationsApp.sendLocalTimeHelp')"
            />
          </CardSection>
        </Card>
      </LayoutSection>

      <LayoutSection v-if="notification.type === 'welcome'">
        <Card>
          <CardSection>
            {{$t('NotificationsApp.Welcome messages will be sent to any user who newly activates notifications')}}
          </CardSection>
        </Card>
      </LayoutSection>

      <LayoutSection>
        <Card>
          <CardSection>
            <Stack v-if="!theUser.isDemoAccount && notification.status == 'draft'">
              <Button @click="changePage('details')">{{$t('Save + Back')}}</Button>
              <Button @click="changePage('details', false)">{{$t('Back')}}</Button>
              <Button v-if="notification.type === 'manual'" @click="sendTest" style="margin-right: 15px;">{{$t('NotificationsApp.Send Test')}}</Button>
              <Button v-if="notification.type === 'manual'" style="margin-right: 15px;" @click="changePage('save')">{{$t('Save and Continue Later')}}</Button>
              <Button
                v-if="notification.type === 'manual'"
                type="primary"
                @click="send"
                :disabled="loadingCounts || !targetedCount"
              >
                <span v-if="loadingCounts"><Spinner size="small" />&nbsp;</span>
                {{$t('NotificationsApp.Schedule to Send')}} ({{targetedCount}})
              </Button>
              <Button v-if="notification.type === 'welcome'" @click="activateWelcome">{{$t('Activate Now')}}</Button>
              <Button v-if="notification.type === 'welcome'" @click="changePage('saveWelcome')">{{$t('Save and Continue Later')}}</Button>
            </Stack>
          </CardSection>
        </Card>
      </LayoutSection>
    </Layout>
  </ValidationObserver>

</template>

<script>

import moment from 'moment'
// import Utils from '../classes/Utils.class'
import TimezoneUtil from '@/../../shared/TimezoneUtil'

window.moment = moment

export default {
  name: 'EditScheduling',
  inject: ['store'],
  props: {
    notification: Object
  },
  data() {
    return {
      useUserTime: false,
      settings: null,
      timingWarning: null,
      warningInterval: null,
      triggerElapsedTime: [0, 0, 0],
      disableActivating: true,
      notifications: [],
      chosenDate: '',

      loadingCounts: true,
      targetedCount: 0
    }
  },
  mounted() {
    const schedule = this.notification.schedule || {
      optimizeToUserTZ: false,
      date: '',
      time: '',
      triggerElapsedTime: [0, 0, 0]
    }
    this.useUserTime = schedule.optimizeToUserTZ
    //
    if (this.notification.type === 'manual') {
      this.chosenDate = schedule.date ? `${schedule.date} ${schedule.time}` : ''
    }

    this.triggerElapsedTime = schedule.triggerElapsedTime || [0, 0, 0]
    this.triggerElapsedTime = this.triggerElapsedTime.filter(n => n !== 0)
    if (this.triggerElapsedTime.length === 0) {
      this.triggerElapsedTime.push(0)
      this.triggerElapsedTime.push(0)
      this.triggerElapsedTime.push(0)
    } else if (this.triggerElapsedTime.length === 1) {
      this.triggerElapsedTime.push(0)
      this.triggerElapsedTime.push(0)
    } else if (this.triggerElapsedTime.length === 2) {
      this.triggerElapsedTime.push(0)
    }

    this.api.notifications.getSettings()
      .then((response) => {
        this.settings = response.settings[0]
        // it's a hack
        this.warningInterval = setInterval(this.updateTimingWarning, 100)
      })

    this.disableActivating = true

    NProgress.start()
    this.api.notifications.getNotificationCount(this.notification)
      .then((res) => {
        let total = 0
        for (const c of res.counts) {
          total += c.count
        }
        this.targetedCount = total
        this.loadingCounts = false
      })
      .catch((err) => {
        console.log(err)
        this.apiCatch(err.message)
      })
      .finally(() => {
        NProgress.done()
      })
    },
  beforeDestroy() {
    clearInterval(this.warningInterval)
  },
  computed: {
    noEditing() {
      return this.notification.type === 'manual' && this.notification.status !== 'draft'
    },
    accountTimezone() {
      return TimezoneUtil.getTimezoneName(this.store.accountTimezone)
    },
    scheduleTriggeredTimings() {
      return [
        { value: 0, label: this.$t('None') },
        { value: 1, label: this.$t('numberOfMinutes', { count: '45' }) },
        { value: 1 * 60, label: this.$t('1 Hour') },
        { value: 2 * 60, label: this.$t('numberOfHours', { count: '2' }) },
        { value: 3 * 60, label: this.$t('numberOfHours', { count: '3' }) },
        { value: 4 * 60, label: this.$t('numberOfHours', { count: '4' }) },
        { value: 5 * 60, label: this.$t('numberOfHours', { count: '5' }) },
        { value: 6 * 60, label: this.$t('numberOfHours', { count: '6' }) },
        { value: 12 * 60, label: this.$t('numberOfHours', { count: '12' }) },
        { value: 1 * 24 * 60, label: this.$t('1 Day') },
        { value: 2 * 24 * 60, label: this.$t('numberOfDays', { count: '2' }) },
        { value: 3 * 24 * 60, label: this.$t('numberOfDays', { count: '3' }) },
        { value: 5 * 24 * 60, label: this.$t('numberOfDays', { count: '5' }) },
        { value: 10 * 24 * 60, label: this.$t('numberOfDays', { count: '10' }) },
        { value: 15 * 24 * 60, label: this.$t('numberOfDays', { count: '15' }) },
        { value: 20 * 24 * 60, label: this.$t('numberOfDays', { count: '20' }) },
        { value: 25 * 24 * 60, label: this.$t('numberOfDays', { count: '25' }) },
        { value: 30 * 24 * 60, label: this.$t('numberOfDays', { count: '30' }) },
      ]
    }
  },
  methods: {
    niceDays(days) {
      return days.map(n => [this.$t('Sunday'), this.$t('Monday'), this.$t('Tuesday'), this.$t('Wednesday'), this.$t('Thursday'), this.$t('Friday'), this.$t('Saturday')][n]).join(', ')
    },
    updateTimingWarning() {
      if (!this.settings) {
        this.timingWarning = ''
        return
      }
      const m = moment(this.chosenDate)
      if (this.settings.onlyDeliverInTZ.hoursFrom) {
        if (m.hour() < parseInt(this.settings.onlyDeliverInTZ.hoursFrom.substr(0, 2).replace(/^0/, ''), 0)) {
          this.timingWarning = this.$t('NotificationsApp.earlyTimingWarning', [`${this.settings.onlyDeliverInTZ.hoursFrom}`])
          return
        }
      }
      if (this.settings.onlyDeliverInTZ.hoursTo) {
        if (m.hour() > parseInt(this.settings.onlyDeliverInTZ.hoursTo.substr(0, 2).replace(/^0/, ''), 0)) {
          this.timingWarning = this.$t('NotificationsApp.lateTimingWarning', [`${this.settings.onlyDeliverInTZ.hoursTo}`])
          return
        }
      }
      const dayOfWeek = m.day()
      if (!this.settings.onlyDeliverInTZ.days.includes(dayOfWeek)) {
        this.timingWarning = this.$t('NotificationsApp.invalidDayTimingWarning', [`${this.niceDays(this.settings.onlyDeliverInTZ.days)}`])
        return
      }
      this.timingWarning = ''
    },
    changePage(nextPage, forceSave = true) {
      if (forceSave) {
        const date = this.notification.type === 'manual' ? this.chosenDate.split(' ') : ['', '']
        this.$emit('update', {
          nextPage,
          date: date[0],
          time: date[1],
          optimizeToUserTZ: this.useUserTime,
          triggerElapsedTime: this.triggerElapsedTime.sort((a, b) => a - b)
        })
      } else {
        this.$emit('goToPage', nextPage)
      }
    },
    send() {
      const self = this
      this.$ui.confirm({
        title: this.$t('NotificationsApp.Schedule to Send'),
        content: this.$t('NotificationsApp.sendNotificationNowMessage'),
        onConfirm() {
          self.changePage('send')
        }
      })
    },
    activateWelcome() {
      const self = this
      this.$ui.confirm({
        title: this.$t('NotificationsApp.Activate Welcome Notification?'),
        onConfirm() {
          self.changePage('activateWelcome')
        }
      })
    },
    activateTriggered() {
      const self = this
      this.$ui.confirm({
        title: this.$t('NotificationsApp.Activate Triggered Notification?'),
        onConfirm() {
          self.changePage('activateTriggered')
        }
      })
    },
    sendTest() {
      const getCookie = (name) => {
        const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`)
        return v ? v[2] : null
      }

      const fpCookie = getCookie('fanplayr')
      let currentUserKey = ''
      let jdc

      if (fpCookie) {
        const dc = decodeURIComponent(fpCookie)
        try {
          jdc = JSON.parse(dc)
        } catch (e) {
          //
        }
        currentUserKey = (jdc && jdc.uk) || ''
      }

      const self = this

      this.$ui.prompt({
        title: this.$t('NotificationsApp.Send Test Message?'),
        inputPlaceholder: this.$t('User Key'),
        inputValue: currentUserKey,
        onSubmit(userKey) {
          self.api.notifications.sendTestNotification(self.notification, userKey)
            .then(() => {
              // console.log(response)
              self.$ui.alert({
                title: self.$t('NotificationsApp.Notification sent')
              })
            })
            .catch((err) => {
              self.$ui.alert({
                title: self.$t('Error'),
                content: err.message
              })
            })
        }
      })
    }
  },
  components: {
  }
};
</script>

<style lang="less" scoped>
  .info {
    background: #eee;
    padding: 10px;
    font-size: 90%;
    margin-bottom: 20px;
  }
  .btn-back-only {
    margin-left: 15px;
  }
</style>
